import { ChevronLeft, ChevronRight } from 'lucide-react';
import { type ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import { Button } from '@/shared/ui';

export const PortfolioOrderCarousel = ({
  children,
  count,
}: {
  children: ReactNode;
  count: number;
}) => {
  const viewport = useRef<HTMLOListElement>(null);
  const [previous, setPrevious] = useState(false);
  const [next, setNext] = useState(false);
  const measure = useCallback(() => {
    const list = viewport.current;
    if (!list) return;
    setPrevious(list.scrollLeft > 1);
    setNext(list.scrollWidth - list.clientWidth - list.scrollLeft > 1);
  }, []);
  useEffect(() => {
    if (count === 0) {
      setPrevious(false);
      setNext(false);
      return;
    }
    measure();
    const list = viewport.current;
    if (!list || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(measure);
    observer.observe(list);
    return () => observer.disconnect();
  }, [count, measure]);
  return (
    <div className="flex items-center gap-2 sm:gap-3">
      <Button
        type="button"
        size="sm"
        variant="outline"
        className="shrink-0 px-2"
        aria-label="이전 사례 보기"
        disabled={!previous}
        onClick={() => {
          const list = viewport.current;
          if (list) list.scrollBy({ left: -list.clientWidth, behavior: 'smooth' });
        }}
      >
        <ChevronLeft aria-hidden="true" />
      </Button>
      <ol
        ref={viewport}
        aria-label="홈 선택 사례 순서"
        onScroll={measure}
        className="grid min-w-0 flex-1 auto-cols-[100%] grid-flow-col gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory py-2 [scrollbar-width:none] sm:auto-cols-[calc((100%_-_1rem)/2)] lg:auto-cols-[calc((100%_-_3rem)/4)]"
      >
        {children}
      </ol>
      <Button
        type="button"
        size="sm"
        variant="outline"
        className="shrink-0 px-2"
        aria-label="다음 사례 보기"
        disabled={!next}
        onClick={() => {
          const list = viewport.current;
          if (list) list.scrollBy({ left: list.clientWidth, behavior: 'smooth' });
        }}
      >
        <ChevronRight aria-hidden="true" />
      </Button>
    </div>
  );
};
